<template>
	<div id="dwt-container" style="width: 100%; height: 100%">
        <iframe :src="scanUrl" style="width: 100%; height: 100%" frameborder="0" id="" name=""></iframe>        
    </div>
</template>

<script>
    import constants from '@/assets/js/constants.js'

	export default {
		name: 'dwt',
        props: {
            categoryId: { type: Number, default: 0 },
            dialogModelShow: { type: Boolean, default: false },
        },
		data () {
			return {
                scanUrl: '',
			}
		},
		mounted()
		{
            sessionStorage.setItem('ctsApiUrl', constants.ctsApiUrl);
            sessionStorage.setItem('scan_jwt_token', sessionStorage.getItem('user'));
            sessionStorage.setItem('ctsApiUrl', constants.ctsApiUrl);
            sessionStorage.setItem('DwtCategory',this.categoryId)
            
            this.scanUrl = '/resources/scan2/scan2.html?lang='+ this.$i18n.locale +  '&r=' + new Date().getTime();
		},
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
					{
						sessionStorage.setItem('scan_jwt_token', sessionStorage.getItem('user'));
						sessionStorage.setItem('ctsApiUrl', constants.ctsApiUrl);
                        sessionStorage.setItem('DwtCategory',this.categoryId)
						this.scanUrl = '/resources/scan2/scan2.html?lang='+ this.$i18n.locale +  '&r=' + new Date().getTime();
					}
                    else
                    {
                        this.scanUrl = ''
                    }
                }
            },
        },
	}
</script>

<style scoped>
    #dwt-container { display: flex; height: inherit; width: inherit; }
    #dwt-control { max-width: 400px; }
</style>